import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const PageHero = ({ eyebrow, title, image, tall = false, testid }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "20%"]);

  return (
    <section ref={ref} className={`relative overflow-hidden ${tall ? "min-h-[70vh]" : "min-h-[55vh]"} flex items-end`} data-testid={testid}>
      <motion.div style={{ y }} className="absolute inset-0 -bottom-24">
        <img src={image} alt="" className="h-full w-full object-cover object-[center_30%]" />
        <div className="absolute inset-0 bg-ink/40" />
      </motion.div>
      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 lg:px-10 pb-16 pt-40">
        {eyebrow && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xs tracking-[0.35em] uppercase text-cream/80 mb-6"
          >
            {eyebrow}
          </motion.p>
        )}
        <div className="overflow-hidden">
          <motion.h1
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, delay: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="font-serif text-cream text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-4xl"
          >
            {title}
          </motion.h1>
        </div>
      </div>
    </section>
  );
};
